document.addEventListener("DOMContentLoaded", function () {

  const productDisplayPrice = document.querySelector('.price-group');
  const mutationObserverElement = document.querySelector('.product-form__cart-submit');
  const subDescriptionElement = document.querySelector('[data-td-sub-description]')?.getAttribute('data-td-sub-description')

  let rcSubscriptionOnly;
  let sellingPlan;
  let productPriceElement;


  function handleChanges() {
    rcSubscriptionOnly = document.querySelector('.rc-subscription-only');
    sellingPlan = document.querySelector('.rc-selling-plans');
    productPriceElement = document.querySelector('[data-rc-compare-price]');
    updateElements();
  }


  function updateElements() {
    if (rcSubscriptionOnly && sellingPlan && productPriceElement) {
      const existingTopWrapper = rcSubscriptionOnly.querySelector('.td-sub-only__top-wrapper');
      const newPrice = productPriceElement.innerHTML;
  
      if (existingTopWrapper) {
        const priceElement = existingTopWrapper.querySelector('.td-sub-only__price');
        if (priceElement) {
          priceElement.innerHTML = newPrice;
        }
      } else {
        const markup = `
          <div class="td-sub-only__top-wrapper">
            <div class="td-sub-only__price">
              ${newPrice}
            </div>
            <div class="td-sub-only__auto-renewal">
              Auto-Renewal
            </div>
          </div>
          <p class="td-sub-only__copy">
          ${subDescriptionElement ? subDescriptionElement : ''}
          </p>
        `;
  
        sellingPlan.classList.add('td-selling-plan__sub-only');
        rcSubscriptionOnly.insertAdjacentHTML('afterbegin', markup);  
      }
    }
  }

  handleChanges();

  let observer = new MutationObserver(handleChanges);
  observer.observe(mutationObserverElement, { childList: true, subtree: true, attributes: true });

  function disconnectObserver() {
    if (observer) {
      observer.disconnect();
      observer = null;
    }
  }

  window.addEventListener('beforeunload', disconnectObserver);
});
